import React, { useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BONUSES, goToCheckout } from '../lib/constants';
// Swipeable, Instagram-style bonus gallery with an individual preview for every bonus.
export function BonusSection() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollToBonus = (index: number) => {
    const carousel = carouselRef.current;
    const card = carousel?.children[index] as HTMLElement | undefined;
    card?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  };
  const handleScroll = () => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
    setActiveIndex(Math.max(0, Math.min(index, BONUSES.length - 1)));
  };
  return <section className="px-5 py-8" data-id="element-26">
      <div className="mx-auto max-w-md" data-id="element-27">
        <h2 className="text-center font-[Montserrat] text-xl font-extrabold leading-snug text-white" data-id="element-28">
          Para que asegures tu plaza al 100% este pack incluye:
        </h2>

        <div className="mx-auto mt-4 flex w-fit items-center gap-2 rounded-full bg-emerald-500 px-4 py-1.5 text-sm font-extrabold text-white shadow-lg shadow-emerald-500/30" data-id="element-29">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" />
          GRATIS solo por el día de hoy
        </div>

        <p className="mt-6 text-center text-sm font-semibold text-blue-100" data-id="element-31">
          Desliza para descubrir tus 7 bonos exclusivos
        </p>

        <div className="relative mt-3" data-id="element-32">
          <div ref={carouselRef} onScroll={handleScroll} aria-label="Carrusel de bonos del Pack PER" className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-33">
            {BONUSES.map((bonus, index) => <article key={bonus.title} className="w-[calc(100%-2.5rem)] flex-none snap-center overflow-hidden rounded-2xl border border-[#c8a24a]/45 bg-[#0b2545] shadow-xl shadow-black/20" data-id="element-34">
                <button type="button" onClick={goToCheckout} aria-label={`Ver la oferta del bono: ${bonus.title}`} className="block w-full bg-white" data-id="element-35">
                  <img src={bonus.previewImage} alt={`Vista previa del bono: ${bonus.title}`} className="aspect-[4/3] w-full object-cover object-top" data-id="element-36" />
                </button>

                <div className="p-4" data-id="element-37">
                  <div className="flex items-start gap-2" data-id="element-38">
                    <span className="text-xl" aria-hidden="true" data-id="element-39">
                      {bonus.emoji}
                    </span>
                    <h3 className="flex-1 font-[Montserrat] text-base font-extrabold leading-snug text-white" data-id="element-40">
                      {bonus.title}
                    </h3>
                  </div>
                  <span className="mt-3 inline-flex rounded-full bg-emerald-500 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-white" data-id="element-41">
                    Gratis hoy
                  </span>
                  <p className="mt-3 text-sm leading-relaxed text-blue-100" data-id="element-42">
                    {bonus.description}
                  </p>
                  <button type="button" onClick={goToCheckout} className="mt-4 text-sm font-bold text-[#e6c168] underline underline-offset-4" data-id="element-43">
                    Quiero este bono →
                  </button>
                </div>
              </article>)}
          </div>

          <button type="button" aria-label="Ver bono anterior" onClick={() => scrollToBonus(Math.max(0, activeIndex - 1))} disabled={activeIndex === 0} className="absolute left-2 top-[30%] flex h-9 w-9 items-center justify-center rounded-full bg-[#061a33]/90 text-[#e6c168] shadow-lg ring-1 ring-[#c8a24a]/50 disabled:opacity-35" data-id="element-44">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-45" />
          </button>
          <button type="button" aria-label="Ver siguiente bono" onClick={() => scrollToBonus(Math.min(BONUSES.length - 1, activeIndex + 1))} disabled={activeIndex === BONUSES.length - 1} className="absolute right-2 top-[30%] flex h-9 w-9 items-center justify-center rounded-full bg-[#061a33]/90 text-[#e6c168] shadow-lg ring-1 ring-[#c8a24a]/50 disabled:opacity-35" data-id="element-46">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-47" />
          </button>
        </div>

        <div className="mt-2 flex items-center justify-center gap-1.5" aria-label={`Bono ${activeIndex + 1} de ${BONUSES.length}`} data-id="element-48">
          {BONUSES.map((bonus, index) => <button key={bonus.title} type="button" onClick={() => scrollToBonus(index)} aria-label={`Ir al bono ${index + 1}: ${bonus.title}`} aria-current={index === activeIndex ? 'true' : undefined} className={`h-2 rounded-full transition-all ${index === activeIndex ? 'w-5 bg-[#e6c168]' : 'w-2 bg-white/35'}`} data-id="element-49" />)}
        </div>

        <div className="mt-6" data-id="element-50">
          <CtaButton data-id="element-51" />
        </div>
      </div>
    </section>;
}